export class Anchor<T> {
    id: string;
    label: T;
    sublevel?: Anchor<T>[];

    constructor(id: string, label: T, sublevel: Anchor<T>[] = null) {
        this.id = id;
        this.label = label;
        this.sublevel = sublevel;
    }
}
